// src/context/AppEnvContext.js
import React, { createContext, useContext } from 'react';

const AppEnvContext = createContext({});

export const AppEnvProvider = ({ children }) => {
  const envVars = Object.keys(process.env)
    .filter((key) => key.startsWith('REACT_APP_'))
    .reduce((acc, key) => {
      acc[key] = process.env[key];
      return acc;
    }, {});

  // ✅ Log all REACT_APP_ keys and values
  console.log('Loaded Environment Variables:', envVars);

  return (
    <AppEnvContext.Provider value={envVars}>
      {children}
    </AppEnvContext.Provider>
  );
};

export const useAppEnv = () => useContext(AppEnvContext);
